import React, { useEffect, useRef, useState } from 'react';
import HyperLink from 'components/Core/HyperLink';
import downArrow from './images/subnav-down-arrow.svg';
import upArrow from './images/subnav-up-arrow.svg';
import useScrollDirection from 'hooks/useScrollDirection';
import useScrollPosition from 'hooks/useScrollPosition';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import Button from 'components/Core/Button';
import Text from 'components/Core/Text';

import { Container, InnerContainer, MobileNav } from './styles';

const SubNav = ({
  data,
  onFormSubmissionModalMarketoForm,
  slug,
  setStickyHeader,
  setStickyHiddenHeader,
}) => {
  const [isMarketingModalOpen, toggleIsMarketingModalOpen] = useState(false);
  const [isStickyWithHeader, setStickyWithHeader] = useState(false);
  const [isStickyWithoutHeader, setStickyWithoutHeader] = useState(false);
  const [isMobileNavOpen, toggleIsMobileNavOpen] = useState(false);
  const [scrollUp, setScrollUp] = useState(false);
  const [prevYPos, setPrevYPos] = useState(0);
  const ref = useRef(null);
  const currentPage = data.items.find(item => {
    return item.link === slug;
  });
  const currentPageIndex = data.items.indexOf(currentPage);
  const scrollDirection = useScrollDirection({ thresholdPixels: 0 });

  useScrollPosition(
    ({ currPos }) => {
      const subNavRef = ref.current;
      if (subNavRef) {
        if (window.pageYOffset < 80) {
          setStickyWithoutHeader(false);
          setStickyWithHeader(false);
          setStickyHeader(false);
          setStickyHiddenHeader(false);
        } else if (
          scrollDirection === 'down' &&
          Math.abs(currPos.y) >= subNavRef.getBoundingClientRect().top + 130
        ) {
          setStickyWithoutHeader(true);
          setStickyWithHeader(false);
          setStickyHeader(false);
          setStickyHiddenHeader(true);
        } else if (scrollDirection === 'up') {
          if (!scrollUp) setPrevYPos(currPos.y);
          if (Math.abs(currPos.y) < Math.abs(prevYPos) - 400) {
            setStickyHeader(true);
            setStickyWithHeader(true);
            setStickyWithoutHeader(false);
            setStickyHiddenHeader(false);
          }
        }
      }
    },
    [scrollDirection, prevYPos],
    null,
    false,
    0
  );

  useEffect(() => {
    if (scrollDirection === 'up') {
      setScrollUp(true);
    } else {
      setScrollUp(false);
    }
  }, [scrollDirection]);

  useEffect(() => {
    if (isMobileNavOpen) {
      document.body.style.overflowY = 'hidden';
      document.body.style.height = '100%';
    } else {
      document.body.style.overflowY = null;
      document.body.style.height = null;
    }

    return () => {
      document.body.style.overflowY = null;
      document.body.style.height = null;
    };
  }, [isMobileNavOpen]);

  const navigation = (
    <ul>
      {data.items.map((item, index) => {
        return (
          <li>
            <HyperLink
              href={item.link}
              className={index === currentPageIndex && 'sub-nav--link-active'}
            >
              <p fontSize="small">{item.title}</p>
            </HyperLink>
          </li>
        );
      })}
    </ul>
  );

  return (
    <Container
      ref={ref}
      stickyWithoutHeader={isStickyWithoutHeader}
      stickyWithHeader={isStickyWithHeader}
    >
      <InnerContainer isMobileNavOpen={isMobileNavOpen}>
        {data.logo && (
          <HyperLink href={data.logo?.link}>
            <Text type="p" size="large" className="sub-nav--logo">
              {data.logo?.label}
            </Text>
          </HyperLink>
        )}
        {navigation}
        <div className="toolbox-sticky-subnav--right-content">
          <Button
            className="toolbox-sticky-subnav--subscribe"
            type="secondary"
            onClick={() => toggleIsMarketingModalOpen(true)}
          >
            Get Demo
          </Button>
          <ModalMarketingForm
            isModalOpen={isMarketingModalOpen}
            onModalCancel={() => toggleIsMarketingModalOpen(false)}
            inlineMarketingForm={{ marketoForm: onFormSubmissionModalMarketoForm }}
            onFormSuccess={() => toggleIsMarketingModalOpen(false)}
            formButtonLabel="Request A Demo Today"
          />
          <img
            src={isMobileNavOpen ? upArrow : downArrow}
            className="sub-nav--arrow"
            onClick={() => toggleIsMobileNavOpen(!isMobileNavOpen)}
          />
        </div>
        <MobileNav isOpen={isMobileNavOpen}>{navigation}</MobileNav>
      </InnerContainer>
    </Container>
  );
};

export default SubNav;
